
type ButtonProps = {
    title: string,
    notification?: JSX.Element,
    onClick?: () => Promise<void> | void,
    className?: string,
    disabled: boolean,
    main?: boolean
};

const BottomButton = (props: ButtonProps) => {
    return(
        <>
            <div className='button-wrapper' style={{ marginLeft: props.main ? '0px' : undefined }}>
                {
                    props.notification
                }
                <button className={`${props.className? props.className :'primary'} bottomButton`}
                        onClick={()=>props.onClick ? props.onClick() : null}
                        disabled={props.disabled}>
                    {props.title}
                </button>
            </div>
        </>
    )
}

export default BottomButton;
